(() => {
  const MOBILE_MEDIA = window.matchMedia('(max-width: 767px)');

  const initLongDetails = (root = document) => {
    root.querySelectorAll('.momo-product-details__content').forEach((content) => {
      if (content.dataset.momoDetailsReady === 'true') return;
      content.dataset.momoDetailsReady = 'true';

      const prepare = () => {
        if (content.dataset.momoMeasured === 'true') return;
        const previewHeight = Math.max(1800, Math.round(window.innerHeight * 3));
        if (content.scrollHeight <= previewHeight + 80) return;

        content.dataset.momoMeasured = 'true';
        content.style.setProperty('--momo-details-preview-height', `${previewHeight}px`);
        content.classList.add('is-collapsed');

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'momo-details-more';
        button.setAttribute('aria-expanded', 'false');
        button.textContent = 'Show more';
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          button.textContent = expanded ? 'Show more' : 'Show less';
          content.classList.toggle('is-collapsed', expanded);
          if (expanded) {
            content.closest('.momo-product-details')?.scrollIntoView({ block: 'start' });
          }
        });
        content.insertAdjacentElement('afterend', button);
      };

      const details = content.closest('details');
      if (details?.open) requestAnimationFrame(prepare);
      details?.addEventListener('toggle', () => {
        if (details.open) requestAnimationFrame(prepare);
      });
      content.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', prepare, { once: true });
      });
    });
  };

  const initMobileGalleryHeight = (root = document) => {
    root.querySelectorAll("slider-component[id^='GalleryViewer-']").forEach((viewer) => {
      if (viewer.dataset.momoGalleryReady === 'true') return;
      viewer.dataset.momoGalleryReady = 'true';

      const list = viewer.querySelector('.product__media-list');
      if (!list) return;
      const slides = [...list.querySelectorAll('.product__media-item')];
      if (!slides.length) return;
      let frame = 0;

      const closestSlide = () => {
        const center = list.scrollLeft + list.clientWidth / 2;
        return slides.reduce((nearest, slide) => {
          const distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
          return distance < nearest.distance ? { slide, distance } : nearest;
        }, { slide: slides[0], distance: Number.POSITIVE_INFINITY }).slide;
      };

      const applyHeight = (preferredSlide) => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (!MOBILE_MEDIA.matches) {
            list.style.removeProperty('height');
            return;
          }
          const slide = preferredSlide || closestSlide();
          const media = slide?.querySelector('.product__media');
          if (!media) return;
          const style = window.getComputedStyle(slide);
          const padding = parseFloat(style.paddingTop || 0) + parseFloat(style.paddingBottom || 0);
          list.style.height = `${Math.ceil(media.getBoundingClientRect().height + padding)}px`;
        });
      };

      applyHeight(slides.find((slide) => slide.classList.contains('is-active')) || slides[0]);
      list.addEventListener('scroll', () => applyHeight(), { passive: true });
      viewer.closest('media-gallery')?.querySelectorAll('.thumbnail').forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const target = thumbnail.closest('[data-target]')?.dataset.target;
          const slide = target ? document.getElementById(`Slide-${target}`) : null;
          window.setTimeout(() => applyHeight(slide), 80);
        });
      });
      viewer.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', () => applyHeight(), { once: true });
      });
      window.addEventListener('resize', () => applyHeight(), { passive: true });
    });
  };

  const initialize = (root = document) => {
    initLongDetails(root);
    initMobileGalleryHeight(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
